import { SearchsDiseaseResult } from "./disease"
import { SearchsDrugResult } from "./drug"
import { SearchsSenmoniResult } from "./senmoni"
import { SearchsGuideLineResult } from "./guideLine"
import { SearchsConventionResult } from "./convention"
import { SearchsMetaTagResult } from "./metaTag"
import { InsiteModelResult } from "interface/util"

export const SearchStatus = {
  Stop: 0,
  InProgress: 1,
  Progress: 2,
  Finished: 8,
  Error: 9,
} as const

export const CancerStatus = {
  Ready: 0,
  Finished: 1
} as const
export const JournalStatus = {
  Ready: 0,
  Finished: 1
} as const
export const TrialStatus = {
  Ready: 0,
  Finished: 1
} as const
export const DpcStatus = {
  Ready: 0,
  Finished: 1
} as const
export const SenmoniStatus = {
  Ready: 0,
  Finished: 1
} as const
export const GuideLineStatus = {
  Ready: 0,
  Finished: 1
} as const
export const ResearchStatus = {
  Ready: 0,
  Finished: 1
} as const

export const SearchType = {
  List: "list",
  Extend: "extend",
  Search: "search",
  Other: "other"
} as const
export type SearchType = (typeof SearchType)[keyof typeof SearchType]

export type SearchResult = {
  searchId: number
  factor: {
    cancer: number
    journal: number
    author: {
      firstAuthor: number
      secondAuthor: number
      lastAuthor: number
      secondLastAuthor: number
      singleAuthor: number
    }
    trial: number
    dpc: number
    senmoni: number
    guideline: number
    research: number
  }
  taskStatus: {
    cancer: number
    journal: number
    trial: number
    dpc: number
    senmoni: number
    guideline: number
    research: number
  }
} & Omit<SearchRecordResult, "targetListCount">

export type SearchDetailResult = SearchResult & {
  clients?: {
    clientId: number
    clientName: string
  }[]
  disease?: SearchsDiseaseResult[]
  drug?: SearchsDrugResult[]
  senmoni?: SearchsSenmoniResult[]
  guideLine?: SearchsGuideLineResult[]
  convention?: SearchsConventionResult[]
  metaTag?: SearchsMetaTagResult[]
  option?: SearchsOptionResult
}

export type SearchRecordResult = {
  searchId: number
  status: number
  title: string
  searchType: SearchType
  request: string | null
  description: string | null
  manufacturer?: {
    manufacturerId: number
    manufacturerName: string | null
    updateTime: string | null
  }
  journalCount?: number
  trialCount?: number
  researchCount?: number
  kojinCount?: number
  sisetuCount?: number
  targetListCount: number
  evaluationFormId: number | null
  evaluationRecordCount: number | null
  evaluationKojinCount: number | null
  evaluationUploadTime: string | null
  effectiveTime: string
} & InsiteModelResult

export type SearchResultList = {
  list: SearchRecordResult[]
}

export type SearchFormData = {
	manufacturerId: number
	title: string
	groups: number[]
  searchType: string
  request: string
  evaluationFormId: number | null
}

export type SearchDescriptionFormData = {
	description: string
}

export type SearchFactorFormData = {
	cancer?: number | null
	journal?: number | null
	author?: {
		firstAuthor?: number | null
		secondAuthor?: number | null
		lastAuthor?: number | null
		secondLastAuthor?: number | null
		singleAuthor?: number | null
	}
	journalLimit?: number | null
	journalDays?: number | null
	journalMesh?: string | null
	trial?: number | null
	dpc?: number | null
	senmoni?: number | null
	guideline?: number | null
	research?: number | null
}

export type SearchTaskStatusFormData = {
  cancer?: number
  journal?: number
  trial?: number
  dpc?: number
  senmoni?: number
  guideline?: number
  research?: number
}
export type SearchStatusFormData = {
	status?: number
	taskStatus?: SearchTaskStatusFormData
}

export type SearchsOptionResult = {
  gridSisetuCount: number | null
  gridKojinCount: number | null
}

export type SearchsOptionFormData = {
  gridSisetuCount: number | null
  gridKojinCount: number | null
}
